// ============================================================================
// ROLE PERMISSION ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/role-permissions';

export const rolePermissionEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  byRoles: (roles: string) => buildEndpointWithQuery(`${BASE_PATH}/by-roles`, { roles }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

export default rolePermissionEndpoints;
